import React from 'react';
import { isInTrial } from '../../app/utils/flags';

export function UpgradeTierPoster() {
    return <div className='d-flex flex-column align-items-center my-5'>
        <h4><i className="fas fa-lock"></i> This feature is available in the Pro plan</h4>

        <a className="btn btn-success" href="/settings/billing">Upgrade plan</a>
    </div>;
}

export function UpgradeTierButton(props: { size?: 'sm' | 'std', showHint?: boolean, hintColumn?: boolean; }) {
    return <div className={`d-flex ${props.hintColumn ? 'flex-column' : 'align-items-center'}`}>
        {props.showHint && <span className={`badge badge-primary ${props.hintColumn ? 'mb-1' : 'mr-2'}`}>Available in Pro plan</span>}
        <a className={`btn btn-success btn-sm btn-${props.size}`} href="/settings/billing">Upgrade plan</a>
    </div>;
}

export function UpgradeTierInfoSmall() {
    return <div className='d-flex align-items-center h-100'><UpgradeTierBadge /></div>;
}

export function UpgradeTierBadge(props: { inTrialText?: string, inCoreText?: string; }) {
    if (isInTrial()) {
        return <span className='text-nowrap'><span className='badge badge-primary'>{props.inTrialText ?? 'Available in Pro plan'}</span></span>;
    } else {
        return <span className='text-nowrap'><span className='badge badge-primary'>{props.inCoreText ?? 'Upgrade to Pro'}</span></span>;
    }
}